import { useFlairLocalStorage } from '../../../hooks/useFlairLocalStorage';
import { useGoalsContext } from './GoalsContext/GoalsContext';
import { GoalViewBy, isGoalViewBy } from './types';

export const useGoalViewBy = (): [GoalViewBy, (value: GoalViewBy) => void] => {
  const { developmentFrameworkEnabled } = useGoalsContext();
  const [viewBy, setViewBy] = useFlairLocalStorage(
    'goals_view_by',
    GoalViewBy.STATUS,
  );
  return [getSafedViewBy(developmentFrameworkEnabled, viewBy), setViewBy];
};

function getSafedViewBy(
  developmentFrameworkEnabled: boolean,
  viewBy: unknown,
): GoalViewBy {
  if (!isGoalViewBy(viewBy)) {
    return GoalViewBy.STATUS;
  }
  if (viewBy === GoalViewBy.CATEGORY && !developmentFrameworkEnabled) {
    return GoalViewBy.STATUS;
  }
  return viewBy;
}
